import { render, staticRenderFns } from "./BlockType1.vue?vue&type=template&id=61e96ff6&scoped=true"
import script from "./BlockType1.vue?vue&type=script&lang=ts"
export * from "./BlockType1.vue?vue&type=script&lang=ts"
import style0 from "./BlockType1.vue?vue&type=style&index=0&id=61e96ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e96ff6",
  null
  
)

export default component.exports